module.exports = __webpack_public_path__ + "img/zcps.bba87095.png";